import { SEARCH_DOCUMENTS } from '@/data/search-content';
import { lazy } from 'react';
import Loadable from '@/components/Loadable';
import TransparentHeaderLayout from '@/layout/transparent-header-layout';
import { Navigate } from 'react-router-dom';
const PortfolioDetailPage = Loadable(lazy(() => import('@/pages/portfolio/[name]/portfolio-detail-page')));
import LandingPage from '@/pages/landing-page';

const SearchDocumentPage = Loadable(lazy(() => import('@/pages/search-document')));

const PhilosophyPage = Loadable(
	lazy(() => import('@/pages/intro/philosophy/philosophy-page'))
);
const TurnKeyPage = Loadable(
	lazy(() => import('@/pages/intro/turn-key/turn-key-page'))
);
const ProcessPage = Loadable(
	lazy(() => import('@/pages/intro/process/process-page'))
);
const PortfolioPage = Loadable(
	lazy(() => import('@/pages/portfolio/portfolio-page'))
);
const ColumnPage = Loadable(lazy(() => import('@/pages/coulmn/column-page')));
const FAQPage = Loadable(lazy(() => import('@/pages/faq/faq-page')));
const NotFoundPage = Loadable(lazy(() => import('@/pages/404/not-found-page')));

// 랜딩페이지는 헤더가 달라서 별도로 정의. 랜딩페이지에서만 사용함.
const TransparentHeaderRoutes = {
	path: '/',
	element: <TransparentHeaderLayout />,
	children: [
        ...SEARCH_DOCUMENTS.map(doc => ({ path: doc.path.slice(1), element: <SearchDocumentPage /> })),
		{
			path: '',
			element: <LandingPage />
		},
		{
			path: 'intro',
			element: <Navigate to={'philosophy'} />
		},
		{
			path: 'intro/philosophy',
			element: <PhilosophyPage />
		},
		{
			path: 'intro/turn-key',
			element: <TurnKeyPage />
		},
		{
			path: 'intro/process',
			element: <ProcessPage />
		},
		{
			path: 'portfolio',
			element: <PortfolioPage />
		},
		{
			path: 'portfolio/:name',
			element: <PortfolioDetailPage />
		},
		{
			path: 'column',
			element: <ColumnPage />
		},
		{
			path: 'faq',
			element: <FAQPage />
		},
		{
			path: '*',
			element: <NotFoundPage />
		}
	]
};

export default TransparentHeaderRoutes;
